import Styles from "@utils"

import { logTool } from "."

const log = logTool(false)

const { scrollUp, scrollDown } = Styles

const body = document.getElementsByTagName("body")[0]

class HeaderMenu {
  constructor() {
    this.scrollUp = scrollUp
    this.scrollDown = scrollDown

    this.lastScrollY = 0
    this.currentScroll = 0

    this.dir = 0 // 1 = down, -1 = up
    this.changed = 0
    this.distance = 0

    this.consideredTop = 160 // what is considered the top of the page
    this.offset = 200 // wait to hide based on this
    this.onset = 50 // wait to show based on this
  }

  init() {
    if (this.currentScroll <= 0) {
      body.classList.remove(this.scrollUp)
    }
  }

  /**
   * When looking at the top, we enlarge it by what we "consider" the top
   * So, is the currentScroll greater than the "considered top" position?
   * @returns {boolean}
   */
  isTop() {
    const result = this.consideredTop > this.currentScroll
    return result
  }

  /**
   * For going down, we only hide if:
   *  1) the current scroll position is greater than what is "considered top"
   *  2) difference from last direction change vs the "offset" value
   * @returns {boolean}
   */
  shouldHide() {
    let result = false
    result = !this.isTop()
    result = result && this.distance > this.offset
    return result
  }

  /**
   * Define the simple test case of what is considered downward motion.
   *  1) the current scroll is bigger than the last scroll, limited by the offset
   */
  isGoingDown() {
    let result = false
    result = this.currentScroll > this.lastScrollY // && !body.classList.contains(scrollDown)
    return result
  }

  shouldShow() {
    // double check for the top with the currentScroll - if you go from bottom to top, this.distance may not be updated
    return this.distance > this.onset || this.currentScroll <= 0
  }

  /**
   * Effectively, any trip up, is a valid up condition.
   * So, we always show when we go up.
   */
  isGoingUp() {
    let result = false
    result = this.currentScroll < this.lastScrollY // && body.classList.contains(scrollDown)
    return result
  }

  // HIDE
  needsDownHideClass() {
    return !body.classList.contains(this.scrollDown)
  }

  // SHOW
  needsUpClass() {
    return !body.classList.contains(this.scrollUp)
  }

  toggleMenu() {
    const remove = this.dir === -1 ? this.scrollDown : this.scrollUp
    const add = this.dir === -1 ? this.scrollUp : this.scrollDown
    body.classList.remove(remove)
    body.classList.add(add)
  }

  updater() {
    this.currentScroll = window.pageYOffset

    // HIDE
    if (this.isGoingDown()) {
      if (this.dir !== 1) {
        this.dir = 1
        this.distance = 0
        this.changed = this.currentScroll
      } else {
        this.distance = Math.abs(this.changed - this.currentScroll)
      }
      if (this.needsDownHideClass()) {
        log("...waiting for hide...")
        if (this.shouldHide()) {
          this.toggleMenu()
        }
      }
      // SHOW
    } else if (this.isGoingUp()) {
      if (this.dir !== -1) {
        this.dir = -1
        this.distance = 0
        this.changed = this.currentScroll
      } else {
        this.distance = Math.abs(this.changed - this.currentScroll)
      }
      if (this.needsUpClass()) {
        log("...waiting to show...")
        if (this.shouldShow()) {
          this.toggleMenu()
        }
      }
    } else {
      this.dir = 0
      log("Not going up or down?", this)
    }

    this.lastScrollY = this.currentScroll

    if (this.lastScrollY === 0) {
      this.dir = 0
      this.changed = 0
      this.distance = 0
    }
  }
}

const addScrollListener = scrollInstance => {
  scrollInstance.init()
  window.addEventListener("scroll", () => {
    let ticker = false
    if (!ticker) {
      window.requestAnimationFrame(() => {
        scrollInstance.updater()
        ticker = false
      })
      ticker = true
    }
  })
}

const initScrollSupport = () => {
  log("initScrollSupport")
  addScrollListener(new HeaderMenu())
}

export default initScrollSupport
